import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import {
  FitTextModule,
  FormFieldModule,
  TextsFilterComponent,
  TimerModule,
} from '@shared/components/games';
import { PicturesFilterModule } from '@shared/components/games/pictures-filter/pictures-filter.module';
import { ChainMemoryControllerComponent } from './chain-memory-controller/chain-memory-controller.component';
import { ChainMemoryCorrectAnswerPreviewComponent } from './chain-memory-preview/chain-memory-answer-preview/chain-memory-answer-preview.component';
import { ChainMemoryExamplePreviewComponent } from './chain-memory-preview/chain-memory-example-preview/chain-memory-example-preview.component';
import { ChainMemoryParametersPreviewComponent } from './chain-memory-preview/chain-memory-parameters-preview/chain-memory-parameters-preview.component';
import { ChainMemoryUserAnswerPreviewComponent } from './chain-memory-preview/chain-memory-user-answer-preview/chain-memory-user-answer-preview.component';
import { ChainMemorySettingsComponent } from './chain-memory-settings/chain-memory-settings.component';

@NgModule({
  declarations: [
    ChainMemoryControllerComponent,
    ChainMemorySettingsComponent,
    ChainMemoryCorrectAnswerPreviewComponent,
    ChainMemoryExamplePreviewComponent,
    ChainMemoryParametersPreviewComponent,
    ChainMemoryUserAnswerPreviewComponent,
  ],
  exports: [
    ChainMemoryControllerComponent,
    ChainMemorySettingsComponent,
    NgSelectModule,
    ChainMemoryCorrectAnswerPreviewComponent,
    ChainMemoryExamplePreviewComponent,
    ChainMemoryParametersPreviewComponent,
    ChainMemoryUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FitTextModule,
    TimerModule,
    NgSelectModule,
    PicturesFilterModule,
    TextsFilterComponent,
    FormFieldModule,
    GamesSharedModule,
  ],
})
export class ChainMemoryModule {}
